import { render, staticRenderFns } from "./NCustomForm.vue?vue&type=template&id=386a6270"
import script from "./NCustomForm.vue?vue&type=script&lang=js"
export * from "./NCustomForm.vue?vue&type=script&lang=js"
import style0 from "./NCustomForm.vue?vue&type=style&index=0&id=386a6270&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports